import React from 'react';
import Markdown from 'react-remarkable';

import Magazine from '../Magazine/Magazine';
import Newsletter from '../Newsletter/Newsletter';

import './Modules.scss';
import moment from 'moment';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const cleanUrl = string => {
  const regex = /([^\d\w-]+)/g;
  if (!!string) {
    return string.replace(regex, '-');
  }
};

const ModuleBlogNewsletter = ({
  isMobile,
  hasBlog,
  uiVariantBlogNewsletter,
  posts,
  primaryColor,
  home,
}) => {
  const renderMagazine = () => {
    if (isMobile) {
      return renderMagazineNewsletterMobile();
    } else {
      return renderMagazineNewsletterDesktop();
    }
  };

  const renderMagazineNewsletterDesktop = () => {
    return (
      <div className="hidden-mobile container">
        <div className="row">
          {!!hasBlog && posts.length > 0 && (
            <div
              className={`${
                uiVariantBlogNewsletter === '3' ? 'col-lg-12' : 'col-lg-8'
              }`}
            >
              <Magazine
                posts={posts}
                primaryColor={primaryColor}
                uiVariantBlogNewsletter={uiVariantBlogNewsletter}
              />
            </div>
          )}
          <div
            className={`${
              !!hasBlog && posts.length > 0 && uiVariantBlogNewsletter !== '3'
                ? 'col-lg-4'
                : 'col-sm-12'
            }`}
          >
            <Newsletter
              primaryColor={primaryColor}
              newsletterTitle={home.newsletterTitle}
              isFullWidth={
                !hasBlog || posts.length < 1 || uiVariantBlogNewsletter === '3'
              }
              uiVariantBlogNewsletter={uiVariantBlogNewsletter}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderMagazineNewsletterMobile = () => {
    return (
      <div className="hidden-desktop mobile-module-blog-newsletter">
        {!!hasBlog && posts.length > 0 && (
          <>
            <div
              className="container"
              style={{
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Blog</div>
              <div>
                <a
                  aria-label="Guarda tutti i nostri articoli"
                  href="/blog"
                  style={{ color: primaryColor }}
                >
                  Vedi tutti
                </a>
              </div>
            </div>
            <div className="mobile-blog-list-container">
              {posts.map(post => {
                const postLink = `/blog/${post.id}-${!!post.title &&
                  cleanUrl(post.title)}`;
                return (
                  <div className="mobile-blog-container">
                    {!!post.featuredImageUrl && (
                      <div className="mobile-blog-image">
                        <a
                          href={postLink}
                          aria-label={`Leggi il nostro articolo "${post.title}"`}
                        >
                          <ImageDispatcher
                            alt={`Immagine di copertina dell'articolo "${post.title}"`}
                            src={post.featuredImageUrl}
                          />
                        </a>
                      </div>
                    )}
                    <div className="mobile-blog-text-container">
                      {!!post.title && (
                        <a
                          href={postLink}
                          aria-label={`Leggi il nostro articolo "${post.title}"`}
                          style={{ color: primaryColor }}
                        >
                          <div className="mobile-blog-title">{post.title}</div>
                        </a>
                      )}
                      {!!post.date && (
                        <div className="mobile-blog-date">
                          {moment(post.date)
                            .locale('it')
                            .format('DD MMMM YYYY')}
                        </div>
                      )}
                      {!!post.excerpt && (
                        <div className="mobile-blog-description">
                          <Markdown
                            source={post.excerpt.split('\n\n').join('\n')}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
        <div className="container">
          <div className="row">
            <div
              className={`${
                !!hasBlog && posts.length > 0 && uiVariantBlogNewsletter !== '3'
                  ? 'col-lg-4'
                  : 'col-sm-12'
              }`}
            >
              <Newsletter
                primaryColor={primaryColor}
                newsletterTitle={home.newsletterTitle}
                isFullWidth={
                  !hasBlog ||
                  posts.length < 1 ||
                  uiVariantBlogNewsletter === '3'
                }
                uiVariantBlogNewsletter={uiVariantBlogNewsletter}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <>{renderMagazine()}</>;
};

export default ModuleBlogNewsletter;
